module.exports = __webpack_public_path__ + "img/gb95-85.prt.46ae936f.jpg";